// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20QE5","top":"styles_top__250dM","left":"styles_left__35uAR","description":"styles_description__3Zwqy"};